import {
    Typography,
    TableRow,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { StyledTableCell } from "../../table/BaseTable/BaseTable";
import { roundToDecimalPlaces } from "../../../helpers/methods";
import { useDiscountedPrice } from "./utils";
import { getCalculatedPricingForProduct } from "../../../utils";
import { useFormContext } from "react-hook-form";
import { PriceDisplay } from "../../common/PriceDisplay";


export function DiscountSummaryRow(props){
    const { t } = useTranslation();

    const { products, fields, gross} = props;
    const { watch } = useFormContext();

    const totalDiscount = () => products.reduce((currvalue, product)=>{
        const pricing = getCalculatedPricingForProduct(product)
        const productPrice = gross ? pricing.listed.gross : pricing.listed.net
        const discountPercent = watch(`${fields.discount}.${product.id}`) || 0;
        const discount = roundToDecimalPlaces((productPrice * discountPercent) / 100, 2)
        return currvalue + discount
    }, 0).toFixed(2) + " zł" 


    const totalPrice = () => products.reduce((currvalue, product)=>{
        const isNoFootage = product.type?.no_footage || false;
        const pricing = getCalculatedPricingForProduct(product)

        return currvalue + roundToDecimalPlaces((gross ? pricing.listed.gross : pricing.listed.net), 2)
    }, 0).toFixed(2) + " zł"

    const totalMinPrice = () => products.reduce((currvalue, product)=>{
        const isNoFootage = product.type?.no_footage || false;
        const pricing = getCalculatedPricingForProduct(product)

        return currvalue + roundToDecimalPlaces((gross ? pricing.minSale.gross : pricing.minSale.net), 2)
    }, 0).toFixed(2) + " zł"

    const totalDiscountedPrice = () => products.reduce((currvalue, product)=>{
        const isNoFootage = product.type?.no_footage || false;
        const pricing = getCalculatedPricingForProduct(product)

        const discountedPriceGross = useDiscountedPrice(
            `${fields.discount}.${product.id}`,
            isNoFootage ? pricing.listed.gross_per_sqm : pricing.listed.gross,
        );
        const discountedPriceNet = useDiscountedPrice(
            `${fields.discount}.${product.id}`,
            isNoFootage ? pricing.listed.net_per_sqm : pricing.listed.net,
        );

        return currvalue + (gross ? discountedPriceGross : discountedPriceNet)
    }, 0).toFixed(2) + " zł"

    return <TableRow>
        <StyledTableCell colSpan={4}/> 
        <StyledTableCell colSpan={1} align="left">
            <Typography fontWeight={"bold"}>
                {t("agreements.AgreementProductsTable.total")}
            </Typography>
        </StyledTableCell>
        <StyledTableCell colSpan={1} align="left">
            <PriceDisplay price={totalPrice()} style={{fontWeight: "bold"}}/>
        </StyledTableCell>
        <StyledTableCell colSpan={1} align="left">
        </StyledTableCell>
        <StyledTableCell colSpan={1} align="left">
            <PriceDisplay price={totalMinPrice()} style={{fontWeight: "bold"}}/>
        </StyledTableCell>
        <StyledTableCell colSpan={2} align="left">
        </StyledTableCell>
        <StyledTableCell colSpan={1} align="left">
            <PriceDisplay price={totalDiscount()} style={{fontWeight: "bold"}}/>
        </StyledTableCell>
        <StyledTableCell colSpan={1} align="left">
        </StyledTableCell>
        <StyledTableCell colSpan={1} align="left">
            <PriceDisplay price={totalDiscountedPrice()} style={{fontWeight: "bold"}}/>
        </StyledTableCell>
    </TableRow>
}